var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHandIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 20,
    viewBox: "0 0 32 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.1611 6.11087H16.3466L18.9689 4.04002C19.7668 3.40999 19.9027 2.25241 19.2727 1.45469C18.6427 0.656847 17.485 0.520748 16.6874 1.15089C16.6874 1.15089 12.13 4.91222 9.95719 6.46569C8.49013 7.51463 7.12109 8.80573 7.12109 10.719V15.1333C7.12109 17.8215 9.30806 20.0085 11.9962 20.0085C13.9698 20.0085 18.848 20.0085 20.6812 20.0085C21.6979 20.0085 22.522 19.1843 22.522 18.1678C22.522 17.506 22.1716 16.9276 21.6474 16.6031H22.2458C23.2623 16.6031 24.0865 15.779 24.0865 14.7624C24.0865 14.1007 23.7362 13.5222 23.212 13.1978H23.6262C24.6427 13.1978 25.4669 12.3736 25.4669 11.357C25.4669 10.6953 25.1166 10.1168 24.5925 9.79237H30.1609C31.1774 9.79237 32.0016 8.96818 32.0016 7.95162C32.0016 6.93506 31.1778 6.11087 30.1611 6.11087Z",
    fill: "#C74132"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.2298 6.74878H1.03632C0.464011 6.74878 0 7.21279 0 7.7851V18.9708C0 19.5431 0.464011 20.0071 1.03632 20.0071H4.2298C4.80211 20.0071 5.26612 19.5431 5.26612 18.9708V7.7851C5.26612 7.21268 4.80211 6.74878 4.2298 6.74878Z",
    fill: "#C74132"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandIcon);
export default __webpack_public_path__ + "static/media/hand_icon.b5de111d8bf8bb80bc79af4419fddf0f.svg";
export { ForwardRef as ReactComponent };